<template>
    <div>
        <v-row v-if="propertyVersion">
            <v-col>
                <v-card
                    outlined
                    class="pa-3 ma-0"
                    min-height="114"
                >
                    <v-card-title class="pa-0 ma-0 font-weight-light body-2"> 
                        <v-icon small class="mr-2">{{ getIconByText('Imóveis') }}</v-icon>
                        Imóveis
                    </v-card-title>


                    <!-- Version 2 -->
                        <v-row v-if="propertyVersion && propertyVersion == 2" dense class="mt-1">
                            <v-col v-for="dash in dashboard.properties" :key="dash.status" class="text-h4 font-weight-light text-center">
                                <div
                                    v-if="dash.total > 0"
                                    @click="navigateToProperties('admin.properties2.search', {
                                        status: dash.status,
                                        //multiple_colaborator: me.profile === 'Corretor' && dash.status !== 'Ativo' ? me.id : null
                                    })"
                                    class="btn btn-link p-0"
                                    style="cursor: pointer;"
                                >
                                    <span :class="dash.status | statusProperty('--text')">{{ dash.total }}</span>
                                    
                                    <div class="caption black--text">{{ dash.status }}</div> 
                                </div>
                            </v-col>
                            <v-col v-if="dashboard.venda_recentes && dashboard.venda_recentes[0].total > 0" class="text-h4 font-weight-light text-left"> 
                                <div
                                    @click="navigateToProperties('admin.properties2.search', {
                                        status: 'Ativo', 
                                        setor: 'Venda', 
                                        data_cadastro_to: dashboard.venda_recentes[0].data_cadastro_to,
                                        data_cadastro_from: dashboard.venda_recentes[0].data_cadastro_from   
                                    })"
                                    class="btn btn-link p-0"
                                    style="cursor: pointer;"
                                >
                                    <span>{{ dashboard.venda_recentes[0].total }}</span>
                                    
                                    <div class="caption black--text">Recente Vendas</div>
                                </div> 
                            </v-col>
                            <v-col v-if="dashboard.locacao_recentes && dashboard.locacao_recentes[0].total > 0" class="text-h4 font-weight-light text-left"> 
                                <div
                                    @click="navigateToProperties('admin.properties2.search', {
                                        status: 'Ativo', 
                                        setor: 'Locacao', 
                                        data_cadastro_to: dashboard.locacao_recentes[0].data_cadastro_to,
                                        data_cadastro_from: dashboard.locacao_recentes[0].data_cadastro_from  
                                    })"
                                    class="btn btn-link p-0"
                                    style="cursor: pointer;"
                                >
                                    <span>{{ dashboard.locacao_recentes[0].total }}</span>
                                    
                                    <div class="caption black--text">Recente Locação</div>
                                </div>
                            </v-col> 
                        </v-row>
                    <!-- Fim Version 2 -->


                    
                    
                    <!-- Version 1 -->
                        <v-row v-else dense class="mt-1">
                            <v-col v-for="dash in dashboard.properties" :key="dash.status" class="text-h4 font-weight-light text-center">
                                <router-link v-if="dash.total > 0" :to="{ 
                                    name: 'admin.properties.index', 
                                    params: {
                                        status: dash.status,  
                                        multiple_colaborator: me.profile == 'Corretor' && dash.status != 'Ativo' ? [me.id] : ''                           
                                    } 
                                }">
                                    <span :class="dash.status | statusProperty('--text')">{{ dash.total }}</span>
                                    
                                    <div class="caption black--text">{{ dash.status }}</div>    
                                </router-link>
                            </v-col> 
                            <v-col v-if="dashboard.venda_recentes && dashboard.venda_recentes[0].total > 0" class="text-h4 font-weight-light text-left"> 
                                    <router-link :to="{ 
                                        name: 'admin.properties.index', 
                                        params: {
                                            status: 'Ativo', 
                                            setor: 'Venda', 
                                            data_cadastro_to: dashboard.venda_recentes[0].data_cadastro_to,
                                            data_cadastro_from: dashboard.venda_recentes[0].data_cadastro_from                          
                                        } 
                                    }">
                                        <span>{{ dashboard.venda_recentes[0].total }}</span>
                                    </router-link>                                        
                                    
                                    <div class="caption black--text">Recente Vendas</div>    
                            </v-col>
                            <v-col v-if="dashboard.locacao_recentes && dashboard.locacao_recentes[0].total > 0" class="text-h4 font-weight-light text-left"> 
                                    <router-link :to="{ 
                                        name: 'admin.properties.index', 
                                        params: {
                                            status: 'Ativo', 
                                            setor: 'Locacao', 
                                            data_cadastro_to: dashboard.locacao_recentes[0].data_cadastro_to,
                                            data_cadastro_from: dashboard.locacao_recentes[0].data_cadastro_from                          
                                        } 
                                    }">
                                        <span>{{ dashboard.locacao_recentes[0].total }}</span>
                                    </router-link>                                        
                                    
                                    <div class="caption black--text">Recente Locação</div>    
                            </v-col>       
                        </v-row> 
                    <!-- end version 1 -->  

                    </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { singleItems } from '@/constants/menuItems'

export default {
    computed: {
        dashboard() {
            return this.$store.state.dashboard.items.data    
        },

        me () {
          return this.$store.state.auth.me
        },

        tenant() {
            return this.$store.state.tenants.items.data    
        },

        propertyVersion() {
            return this.tenant?.[0]?.json_params?.property_version || '1';
        }
    },  
    
    data () {
        return {
            single_items: singleItems,
        }
    },

    methods: {
        getIconByText(text) {
            const item = this.single_items.find(item => item.text === text)
            return item ? item.icon : 'mdi-help' // ícone padrão se não encontrar
        },

        navigateToProperties(routeName, query = {}) {
            // Filtra valores falsy (null, undefined, '') para não poluir a URL
            const cleanQuery = Object.fromEntries(
                Object.entries(query).filter(([_, value]) => value != null && value !== '')
            );

            this.$router.push({
                name: routeName,
                query: cleanQuery
            }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                console.error('Erro ao navegar:', err);
                }
            });
        }
    }
}
</script>

